export enum Item {
	ADVERTISEMENT = 'advertisement',
	QRLINK = 'qrlink',
	QRCODE = 'qrcode'
}

export enum Type {
	TAKE = 'take',
	DUPLICATE = 'duplicate',
	IGNORE = 'ignore'
}

export interface Duplication {
	item: Item;

	amount: number;

	types: {
		item: Item;
		type: Type;
		title: string;
	}[];
}
